import { Supers } from './utils/supers/supers';
import Vue from 'vue'
import { ViewTool } from './utils/view-tool/view-tool';
import { SoftPhoneUtil } from './utils/soft-phone/soft-phone';
import { Verify } from './utils/verify/verify';
import { Util } from './utils/util/util';
import { Http } from './utils/http/http';
import { AppModal } from './utils/app-modal/app-modal';
import { uiServiceRegister } from '@/api/uiservice/ui-service-register';
import { authServiceRegister } from '@/api/authservice/auth-service-register';
import { utilServiceRegister } from '@/api/utilservice/util-service-register';
import { entityServiceRegister } from '@/api/service/entity-service-register';
import { counterServiceRegister } from '@/api/counter/counter-service-register';
import { codeListRegister } from '@codelist/codelist-register';
import { messageServiceRegister } from '@/api/message/message-service-register';
import AppMenuItem from './components/app-menu-item/app-menu-item.vue'
import AppMessagePopover from './components/app-message-popover/app-message-popover.vue'
import AppHeaderMenus from './components/app-header-menus/app-header-menus.vue'
import AppStudioAction from './components/app-studioaction/app-studioaction.vue'
import Breadcrumb from './components/app-breadcrumb/app-breadcrumb.vue'
import AppDebugActions from './components/app-debug-actions/app-debug-actions.vue'

import AppOrgSector from  './components/app-orgsector/app-orgsector.vue'
import AppKeepAlive from './components/app-keep-alive/app-keep-alive.vue'
import TabPageExp from './components/tab-page-exp/tab-page-exp.vue'
import AppLang from './components/app-lang/app-lang.vue'
import AppTheme from './components/app-theme/app-theme.vue'
import AppUser from './components/app-user/app-user.vue'
import AppForm from './components/app-form/app-form.vue'
import AppFullScren from './components/app-full-scren/app-full-scren.vue'
import AppLockScren from './components/app-lock-scren/app-lock-scren.vue'
import AppChangePassword from "@components/app-change-password/app-change-password.vue";
import Loadding  from  './directive/loadding/loadding';
import AppFileUpload from './components/app-file-upload/app-file-upload.vue'

// 全局挂载UI实体服务注册中心
window['uiServiceRegister'] = uiServiceRegister;
// 全局挂载实体权限服务注册中心
window['authServiceRegister'] = authServiceRegister;
// 全局挂载功能服务注册中心
window['utilServiceRegister'] = utilServiceRegister;
// 全局挂载数据服务注册中心
window['entityServiceRegister'] = entityServiceRegister;
// 全局挂载计数器服务注册中心
window['counterServiceRegister'] = counterServiceRegister;
// 全局挂载代码表服务注册中心
window['codeListRegister'] = codeListRegister;
// 全局挂载视图消息服务注册中心
window['messageServiceRegister'] = messageServiceRegister;

export const AppComponents = {
    install(v: any, opt: any) {
        v.prototype.$appmodal = AppModal.getInstance();
        v.prototype.$http = Http.getInstance();
        v.prototype.$super = Supers.getInstance();
        v.prototype.$bus = new Vue();
        v.prototype.$util = Util;
        v.prototype.$verify = Verify;
        v.prototype.$viewTool = ViewTool;
        v.prototype.$softPhone = new SoftPhoneUtil();
        v.component('app-full-scren',AppFullScren);
        v.component('app-lock-scren',AppLockScren);
        v.component('app-keep-alive',AppKeepAlive);
        v.component('tab-page-exp',TabPageExp);
        v.component('app-lang',AppLang);
        v.component('app-theme',AppTheme);
        v.component('app-user',AppUser);
        v.component('app-form', AppForm);
        v.directive('loading',Loadding);
        v.component('app-menu-item', AppMenuItem);
        v.component('app-message-popover', AppMessagePopover);
        v.component('app-breadcrumb',Breadcrumb);
        v.component('app-header-menus', AppHeaderMenus);
        v.component('app-studioaction', AppStudioAction);
        v.component('app-debug-actions', AppDebugActions);
        v.component('app-orgsector', AppOrgSector);
        v.component('app-change-password', AppChangePassword)
        v.component('app-file-upload',AppFileUpload);
    },
};
